import { api } from './api';

export const loadMentorDatasets = async (platform: string, username: string, pathway: string) => {
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/ai-index/orgs/${platform}/users/${username}/documents/pathways/${pathway}/`;

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Token ${localStorage.getItem('axd_token')}`,
      }
    });

    if (response.ok) {
      return await response.json();
    }
  }catch (err){
    console.error(err);
  }
}

export const toggleTrainDatasets = async (platform: string, username: string, id: string, payload) => {
  const url = `${process.env.REACT_APP_IBL_DM_URL}/api/ai-index/orgs/${platform}/users/${username}/documents/${id}/`;
  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
      headers: {
        'Authorization': `Token ${localStorage.getItem('axd_token')}`,
        'Content-Type': 'application/json'
      }
    });
    if (response.ok) {
      return await response.json();
    }
  }catch (err){
    console.error(err);
  }
}


